import { ApiService } from 'src/app/services/api.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { APIs } from '../config/api.constant';
import { AppConstant } from '../config/app.constant';

@Injectable({
  providedIn: 'root'
})
export class MeetingService {
  constructor(private apiService: ApiService) { }

  getTenantCredit(): Observable<any> {
    return this.apiService.get(APIs.getTenantCredit, { TenantId: localStorage.getItem(AppConstant.localStorage.tenantId) }).pipe(map(response => {
      return response;
    }))
  }
}
